import useAdminChatPageElement from '../../../hooks/adminChats/useAdminChatPageElement';

const ChatPage = () => useAdminChatPageElement();

export default ChatPage;
